/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutTargetType } from './rolloutTargetType';
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { VcdsPersonaEnum } from './vcdsPersonaEnum';


/**
 * Specification to target deployment targets.
 */
export interface DeploymentTargetSpec { 
    type?: RolloutTargetType;
    provider_type: CloudProvidersEnum;
    /**
     * Deployment versions to target, leave empty to query all.
     */
    versions: Array<string>;
    /**
     * Deployment Personas to target, leave empty to query all.
     */
    personas: Array<VcdsPersonaEnum>;
}
export namespace DeploymentTargetSpec {
}


